import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=3ad4e892&scoped=true"
import script from "./DocumentModal.vue?vue&type=script&lang=js"
export * from "./DocumentModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentModal.vue?vue&type=style&index=0&id=3ad4e892&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4e892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad4e892')) {
      api.createRecord('3ad4e892', component.options)
    } else {
      api.reload('3ad4e892', component.options)
    }
    module.hot.accept("./DocumentModal.vue?vue&type=template&id=3ad4e892&scoped=true", function () {
      api.rerender('3ad4e892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/DocumentModal.vue"
export default component.exports